/* eslint-disable no-restricted-globals */
import get from 'lodash/get';

export const reformatNum = string =>
  (string || '')
    .toString()
    .replace(/[^\d]/g, '')
    .trim();

export const amountInput = e => {
  const value = reformatNum(get(e, 'target.value'));
  const valNum = parseInt(value, 10);
  if (isNaN(valNum)) {
    return '';
  }

  return `Rp${valNum.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')}`;
};

export const numericInput = e => {
  const value = reformatNum(e.target.value);
  return value;
};

export const validatorAmountRange = (min, max) => (rule, value, callback) => {
  const amount = parseInt(reformatNum(value), 10);
  if (amount < min) {
    callback(`Value must greater than or equal ${min}`);
  } else if (amount > max) {
    callback(`Value must less than or equal ${max}`);
  } else {
    callback();
  }
};

export const validatorExcel = (rule, value, callback) => {
  if (!value) {
    callback('Wajib diisi');
  } else {
    const ext = value.fileList[0].name.split('.')[1];
    if (ext !== 'xlsx') {
      callback('Format file salah');
    }
    callback();
  }
};

export const validatorCsv = (rule, value, callback) => {
  if (!value) {
    callback('Wajib diisi');
  } else {
    const ext = value.fileList[0].name.split('.')[1];
    if (ext !== 'csv') {
      callback('Format file salah');
    }
    callback();
  }
};
